<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Thêm điểm danh
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="py-6">
        <div class="mb-3">
          * Sau khi thêm điểm danh thành công, thông báo sẽ được gửi đến Phụ huynh (gửi theo Tự động theo đăng ký trong
          Sổ liên lạc)
        </div>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <DateIOSPicker
                label="Ngày"
                :date.sync="datetime"
                outlined
                class="required"
                :rules="[$rules.required, $rules.date, $rules.dateFromNow]"
                dense
              />
            </v-col>
            <v-col cols="12">
              <GradeClassStudentSelect
                ref="gcsSelectForm"
                :gradeCol="{ cols: 12, md: 6 }"
                :classCol="{ cols: 12, md: 6 }"
                :studentCol="{ cols: 12 }"
                :studentRules="[$rules.required]"
                @changed="gradeClassStudentChange"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="selectedBoardingClass"
                :items="classList"
                item-text="name"
                item-value="_id"
                label="Lớp bán trú"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12">
              <div class="d-flex justify-center">
                <v-btn :outlined="status !== 'attendance'" class="mr-2" color="success" @click="onAttend">Có mặt</v-btn>
                <v-btn :outlined="status !== 'absent'" color="warning" @click="onAbsent">Vắng mặt</v-btn>
                <div v-if="status === 'absent'" class="ml-2">
                  <v-btn :outlined="subStatus !== 'excused'" class="mr-2" color="success" @click="onExcused"
                    >Có phép</v-btn
                  >
                  <v-btn :outlined="subStatus !== 'unexcused'" color="warning" @click="onUnexcused">Không phép</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: {
    DateIOSPicker,
    GradeClassStudentSelect,
  },
  data() {
    return {
      dialog: false,
      datetime: moment().toISOString(),
      selectedGrade: {},
      selectedClass: {},
      selectedBoardingClass: {},
      selectedStudent: {},
      classList: [],
      status: 'attendance',
      subStatus: 'none',
    }
  },
  props: {
    state: Boolean,
  },
  computed: {
    ...mapState('boardingClassAttendance', ['date']),
    ...mapState('boardingClass', ['boardingClass']),
    getCurrentDate() {
      return moment(this.date).format('DD/MM/YYYY')
    },
  },
  mounted() {
    this.loadClassList()
  },
  methods: {
    ...mapActions('boardingClass', ['fetchBoardingClass']),
    ...mapActions('boardingClassAttendance', ['getAllAttendances', 'checkinAttendance']),
    async loadClassList() {
      try {
        await this.fetchBoardingClass()
        this.classList = this.boardingClass || []
      } catch (error) {
        console.error('Failed to load class list:', error)
      }
    },
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onAttend() {
      this.status = 'attendance'
      this.subStatus = 'none'
    },
    onAbsent() {
      this.status = 'absent'
      this.subStatus = 'unexcused'
    },
    onExcused() {
      this.subStatus = 'excused'
    },
    onUnexcused() {
      this.subStatus = 'unexcused'
    },
    async save() {
      if (!this.$refs.form.validate() || !this.$refs.gcsSelectForm.validate()) {
        return
      }
      try {
        this.$loading.active = true
        const datetime = moment(this.datetime)
          .date(moment(this.datetime).date())
          .month(moment(this.datetime).month())
          .year(moment(this.datetime).year())
          .toISOString()

        const dateGte = moment(datetime).startOf('day').toISOString()
        const dateLte = moment(datetime).endOf('day').toISOString()

        const attendances = await this.getAllAttendances({
          searchParams: {
            student: this.selectedStudent.id,
            date_gte: dateGte,
            date_lte: dateLte,
          },
          disableSave: true,
        })
        const attendance = attendances[0]
        if (attendance) {
          if (attendance.status === 'attendance') {
            this.$alert.error('Học sinh này đã đến trường')
            return
          }
          if (attendance.status === 'left' && moment(datetime).isSameOrBefore(moment(attendance.datetime))) {
            this.$alert.error('Thời gian đến không hợp lệ.')
            return
          }
        }
        await this.checkinAttendance({
          code: this.selectedStudent.code,
          date: datetime,
          send: true,
          manual: true,
          classId: this.selectedBoardingClass,
          status: this.status,
          subStatus: this.subStatus,
        })
        this.$alert.addSuccess()
        this.reset()
        this.dialog = false
      } catch (error) {
        console.error(error)
        this.$alert.addError()
      } finally {
        this.$loading.active = false
      }
    },
    reset() {
      this.selectedGrade = null
      this.selectedClass = null
      this.selectedBoardingClass = null
      this.selectedStudent = null
      this.datetime = moment().toISOString()
      this.status = 'attendance'
      this.subStatus = 'none'
      this.$refs.form.resetValidation()
      this.$refs.gcsSelectForm.reset()
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
  },
  watch: {
    state(state) {
      this.dialog = true
    },
    dialog(newVal) {
      if (!newVal) {
        this.reset()
      }
    },
  },
}
</script>
